(() => {
  const T = window.Tranche || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };
  const nav = $('#mobile-nav');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => { nav?.setAttribute('aria-hidden', 'false'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => { nav?.setAttribute('aria-hidden', 'true'); $$('[data-menu-open]').forEach(x => x.setAttribute('aria-expanded', 'false')); document.body.style.overflow = ''; }));
  const drawer = () => $('#cart-drawer');
  const openDrawer = () => { const d = drawer(); if (!d) return (location.href = T.routes.cart); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; $('.drawer__close', d)?.focus(); };
  const closeDrawer = () => { const d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  const refreshCart = async () => {
    try {
      const [sec, cart] = await Promise.all([
        fetch(T.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer').then(r => r.json()),
        fetch(T.routes.cart + '.js').then(r => r.json())
      ]);
      const html = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
      const fresh = $('.drawer__panel', html); const cur = $('.drawer__panel', drawer());
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count > 0 ? cart.item_count : '');
      bindAgeGate();
      return cart;
    } catch (err) { console.error(err); }
  };
  const addItems = async (items) => {
    const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Ajout impossible');
    await refreshCart(); openDrawer();
    return data;
  };
  window.TrancheAdd = addItems;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    const line = +btn.dataset.line; const qty = +btn.dataset.qty;
    btn.disabled = true;
    await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, qty) }) });
    if (document.body.classList.contains('template-cart')) return location.reload();
    refreshCart();
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault(); b.setAttribute('aria-busy', 'true');
    try { await addItems([{ id: +b.dataset.quickAdd, quantity: 1 }]); } catch (err) { toast(err.message); }
    b.removeAttribute('aria-busy');
  });
  const bindAgeGate = () => {
    if (!T.ageGate) return;
    $$('[data-age-check]').forEach(cb => {
      const form = cb.closest('form'); const submit = form && $('[name=checkout]', form);
      const sync = () => { if (submit) { submit.disabled = !cb.checked; submit.setAttribute('aria-disabled', String(!cb.checked)); } };
      sync();
      if (cb._bound) return; cb._bound = true;
      cb.addEventListener('change', async () => {
        sync();
        await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Confirmation majorité': cb.checked ? "Oui - l'acheteur certifie avoir 18 ans ou plus" : '' } }) });
      });
    });
  };
  bindAgeGate();
  $$('[data-product-form]').forEach(root => {
    const json = $('[data-product-json]', root.closest('[data-pdp]') || document);
    const product = json ? JSON.parse(json.textContent) : null;
    const idInput = $('[name=id]', root);
    const priceEl = $('[data-price]', root.closest('[data-pdp]'));
    const submit = $('[data-add]', root);
    const qtyInput = $('[name=quantity]', root);
    const currentOptions = () => $$('[data-option]', root).map(fs => ($('input:checked', fs) || {}).value);
    const onChange = () => {
      if (!product) return;
      const opts = currentOptions();
      const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
      if (!v) { submit.disabled = true; return; }
      idInput.value = v.id;
      $$('[data-option-label]', root).forEach((el, i) => el.textContent = opts[i] || '');
      if (priceEl) {
        priceEl.querySelector('.price__current').textContent = money(v.price);
        const cmp = priceEl.querySelector('.price__compare');
        if (cmp) { cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      }
      submit.disabled = !v.available;
      submit.querySelector('[data-add-label]').textContent = v.available ? submit.dataset.labelAvailable : 'Épuisé, bientôt de retour';
      $$('[data-sticky-price]').forEach(el => el.textContent = money(v.price));
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-option] input', root).forEach(i => i.addEventListener('change', onChange));
    $$('[data-qty]', root).forEach(b => b.addEventListener('click', () => { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.dataset.qty)); }));
    const engrave = $('[data-engrave]', root);
    engrave && $('input[type=checkbox]', engrave).addEventListener('change', (e) => { engrave.classList.toggle('is-on', e.target.checked); if (e.target.checked) $('input[type=text]', engrave).focus(); });
    root.addEventListener('submit', async (e) => {
      e.preventDefault();
      const items = [];
      const props = {};
      if (engrave && $('input[type=checkbox]', engrave).checked) {
        const txt = $('input[type=text]', engrave).value.trim();
        if (!txt) { toast('Indiquez le texte à graver ou décochez la gravure.'); return; }
        props['Gravure'] = txt;
        const gid = +engrave.dataset.variant;
        if (gid) items.push({ id: gid, quantity: +qtyInput.value || 1, properties: { 'Pour': product ? product.title : '' } });
      }
      items.unshift({ id: +idInput.value, quantity: +qtyInput.value || 1, properties: props });
      $$('[data-addon]:checked', root).forEach(a => items.push({ id: +a.value, quantity: 1 }));
      submit.setAttribute('aria-busy', 'true'); submit.disabled = true;
      try { await addItems(items); } catch (err) { toast(err.message); }
      submit.removeAttribute('aria-busy'); submit.disabled = false;
    });
  });
  $$('[data-gallery]').forEach(g => {
    const track = $('.gallery__main', g); const thumbs = $$('.gallery__thumb', g); const dots = $$('.gallery__dots span', g);
    thumbs.forEach((t, i) => t.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' })));
    track?.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { passive: true });
  });
  const sticky = $('[data-sticky-atc]'); const anchor = $('[data-add]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(anchor);
    $('button', sticky)?.addEventListener('click', () => anchor.click());
  }
  $$('[data-eta]').forEach(el => {
    const s = T.shipping || { minDays: 7, maxDays: 12, cutoffHour: 18 };
    const addBiz = (d, n) => { const r = new Date(d); let k = 0; while (k < n) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) k++; } return r; };
    const now = new Date(); let start = new Date(now);
    const w = now.getDay();
    if (now.getHours() >= s.cutoffHour || w === 0 || w === 6) start = addBiz(now, 1);
    const f = { weekday: 'long', day: 'numeric', month: 'long' };
    const a = addBiz(start, s.minDays).toLocaleDateString('fr-FR', f); const b = addBiz(start, s.maxDays).toLocaleDateString('fr-FR', f);
    $('[data-eta-text]', el).textContent = 'Livraison estimée entre le ' + a + ' et le ' + b;
  });
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const host = el.closest('[data-offer]');
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) { host ? host.remove() : el.remove(); return; }
      el.querySelector('[data-d]').textContent = pad(Math.floor(diff / 864e5)); el.querySelector('[data-h]').textContent = pad(Math.floor(diff / 36e5) % 24);
      el.querySelector('[data-m]').textContent = pad(Math.floor(diff / 6e4) % 60); el.querySelector('[data-s]').textContent = pad(Math.floor(diff / 1e3) % 60);
      setTimeout(tick, 1000);
    };
    tick();
  });
  requestAnimationFrame(() => $$('.reveal').forEach((el, i) => setTimeout(() => el.classList.add('is-in'), 80 * i)));
})();
